import { render, staticRenderFns } from "./EditCountryTable.vue?vue&type=template&id=68d284a4&scoped=true"
import script from "./EditCountryTable.ts?vue&type=script&lang=ts&external"
export * from "./EditCountryTable.ts?vue&type=script&lang=ts&external"
import style0 from "./EditCountryTable.vue?vue&type=style&index=0&id=68d284a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68d284a4",
  null
  
)

export default component.exports